module.exports = __webpack_public_path__ + "img/success-icon.3a4191a1.png";